import { render } from "./MarcheModal.vue?vue&type=template&id=53facab8&ts=true"
import script from "./MarcheModal.vue?vue&type=script&lang=ts"
export * from "./MarcheModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__